import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { msalPlugin } from '@/plugins/msal.plugin';

import { i18n } from '@/locales';

import { axiosWrapperConfig } from '@/api/config';
import { useAuthStore } from '@/stores';

import router from '@/router';

import '@/assets/styles/index.css';

import App from '@/App.vue';
import { proInstallationApiUrl } from '@/constants';
import axiosWrapper from '@mylight150/axios-wrapper';
import proFoundationApp from '@mylight150/pro-foundation-app';
import regenerativUi from '@regenerativ/regenerativ-ui-vue';
import '@regenerativ/regenerativ-ui-vue/dist/style.css';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

const networkDetailAllowUrls: Array<string> = [
  `^${import.meta.env.VITE_APIM_BASE_URL}${proInstallationApiUrl}`,
];

const authStore = useAuthStore();
authStore.initMsalInstance().then(() => {
  app.use(msalPlugin, { authStore });
  app.use(router);
  app.use(i18n);

  app.use(regenerativUi, { env: import.meta.env.VITE_APP_ENV });
  app.use(proFoundationApp, {
    i18n,
    router,
    pinia,
    dsnSentry: import.meta.env.VITE_SENTRY_DSN,
    env: import.meta.env.VITE_APP_ENV,
    networkDetailAllowUrls,
    gtmId: import.meta.env.VITE_GTM_ID,
  });
  app.use(axiosWrapper, { axiosWrapperConfig });

  router.isReady().then(() => {
    app.mount('#app');
  });
});
